<template>
  <!-- 登录页 -->
  <div class="prod-main">
    <header-general :isWhite="true" type="login" @changeLoginShow="changeLoginShow" />
    <login-box v-show="isShow" @changeLoginShow="changeLoginShow" />
    <Banner class="prod-baner"></Banner>
    <div class="prod-box1-parent">
      <div class="prod-box1">
        <img src="~@/assets/images/indexpage/production/pic1@2x.png"/>
        <div class="right-box">
          <h2><span>员工账号，</span><br>尽享企业专属权益</h2>
          <p class="first-desc">享受企业专属空间、企业专属云端服务如企业数据库、云协同</p>
          <p>支持管理员账号生成员工账号，配置员工加密锁资产和管理造价云空间</p>
          <p>项目集成管理，支持项目管理/编辑权限配置， 告别工程文件的简单存储堆砌</p>
        </div>
      </div>
    </div>
    <div class="prod-box2-parent">
      <div class="prod-box2">
        <div class="left-box">
          <h2><span>专属造价</span><br>不止于存储</h2>
          <p class="first-desc">
            - 试试切换项目阶段，探索全新阶段式存储奥妙
            <br>
          </p>
          <p>- 应有尽有的全新项目文件模板，让一切井然有序</p>
          <p>- 项目成员云端协作，还可以配置管理/编辑权限</p>
          <p>- 体验全新一键备案，开启企业数据积累第一步</p>
        </div>
        <img src="~@/assets/images/indexpage/production/pic2@2x.png"/>
      </div>
    </div>
    <div class="prod-box3-parent">
      <div class="prod-box3">
        <div class="image">
          <img src="~@/assets/images/indexpage/production/pic3@2x.png"/>
        </div>
        <div class="right-box">
          <h2><span>从积累到应用，</span><br>感受数据的价值</h2>
          <p class="first-desc">
            - 企业内部经验数据持续积累，提升核心竞争力
          </p>
          <p>- 支持分配人员进行数据分类审核，企业数据管理更轻松</p>
          <p>- 在线登录端软件，体验企业数据带给您的便捷</p>
        </div>
      </div>
    </div>
    <div class="prod-box4-parent">
      <div class="prod-box4">
        <div class="left-box box4-left">
          <h2><span>企业数据库</span><br>助力企业降本增效</h2>
          <p class="first-desc">- 全新广材，定价有数，效益更优</p>
          <p>- 计价依据库，数据引领市场化清单计价新范式</p>
          <p>- 更多云端新品，请点击试用中心探索</p>
        </div>
        <img src="~@/assets/images/indexpage/production/pic4@2x.png"/>
      </div>
    </div>
    <div class="phone">
      <!--<img src="~@/assets/images/indexpage/production/tel_bg.png" width="100%" />-->
      <!--<p>立即使用造价云，开启轻松工作</p>-->
      <!--<div class="phone-span">-->
      <!--<i class="r2-icon-phone"></i>-->
      <!--<span>4000-166-166</span>-->
      <!--</div>-->
    </div>
    <footer-general type="blocked" />
    <w-backtotop :visibility-height="100" iconName="w-icon-sanjiao-copy2" :custom-style="backToTopCustomStyle" ref="backToTop"></w-backtotop>
  </div>
</template>
<style lang="less" type="text/less">
  .prod-main{
    h1, h2, h3, h4, h5, h6, p, address, ol, ul, dl{
      margin-bottom: 0;
    }
    width: 100%;
    overflow-x: hidden;
    min-width: 1280px;
    text-align: center;
    .prod-baner{
      margin-top: 72px;
    }
    .prod-box1-parent{
      position: relative;
      margin-top: 124px;
      width: 100%;
      height: 473px;
      .prod-box1{
        width: 1300px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        img{
          display: inline-block;
          width: 820px;
          height: 473px;
          max-width: 820px;
          vertical-align: middle;
        }
        .right-box{
          width: 356px;
          text-align: left;
          display: inline-block;
          margin-left: 75px;
          margin-right: 40px;
          margin-top: -70px;
          vertical-align:middle;
          h2{
            font-size:40px;
            color: #000000;
            line-height:64px;
            font-weight: 600;
            span{
              color:rgba(32,121,250,1);
            }
          }
          p{
            &.first-desc{
              margin-top: 26px;
            }
            margin-top: 12px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(33,37,48,0.8);
            line-height: 24px;
          }
        }
      }
    }
    .prod-box2-parent{
      position: relative;
      margin-top: 208px;
      width: 100%;
      height: 501px;
      .prod-box2{
        width: 1400px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        .left-box{
          display: inline-block;
          text-align: left;
          margin-right: 98px;
          margin-left: 50px;
          margin-top: -86px;
          vertical-align:middle;
          h2{
            font-size:40px;
            font-weight:600;
            color: #000000;
            line-height:64px;
            span{
              color:rgba(32,121,250,1);
            }
          }
          p{
            &.first-desc{
              margin-top: 22px;
            }
            font-size: 16px;
            font-weight: 400;
            color: rgba(33,37,48,0.8);
            line-height:32px;
          }
        }
        .box4-left{
          h2{
            height:104px;
          }
        }
        img{
          display: inline-block;
          width: 816px;
          height: 501px;
          max-width: 816px;
          vertical-align: middle;
        }
      }
    }
    .prod-box3-parent{
      position: relative;
      margin-top: 124px;
      width: 100%;
      height: 491px;
      .prod-box3{
        width: 1200px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        .image {
          width: 829px;
          position: absolute;
          left: -158px;
          img{
            display: inline-block;
            width: 829px;
            height: 491px;
            max-width: 829px;
            vertical-align: middle;
          }
        }
        .right-box{
          width: 402px;
          text-align: left;
          /*display: inline-block;*/
          margin-left: 72px;
          /*margin-right: 40px;*/
          /*margin-right: 160px;*/
          margin-top: 160px;
          float: right;
          /*vertical-align:middle;*/
          h2{
            font-size:40px;
            color: #000000;
            line-height:64px;
            font-weight: 600;
            span{
              color:rgba(32,121,250,1);
            }
          }
          p{
            &.first-desc{
              margin-top: 22px;
            }
            font-size: 16px;
            font-weight: 400;
            color: rgba(33,37,48,0.8);
            line-height: 32px;
          }
        }
      }
    }
    .prod-box4-parent{
      position: relative;
      margin-top: 188px;
      width: 100%;
      height: 371px;
      .prod-box4{
        width: 1300px;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        .left-box{
          display: inline-block;
          text-align: left;
          /*margin-left: 40px;*/
          margin-right: 60px;
          vertical-align:middle;
          width: 398px;
          h2{
            font-size:40px;
            font-weight:600;
            color: #000000;
            line-height:64px;
            span{
              color:rgba(32,121,250,1);
            }
          }
          p{
            &.first-desc{
              margin-top: 22px;
            }
            font-size: 16px;
            font-weight: 400;
            color: rgba(33,37,48,0.8);
            line-height: 32px;
          }
        }
        img{
          display: inline-block;
          width: 741px;
          height: 371px;
          max-width: 741px;
          vertical-align: middle;
        }
      }
    }

    .phone{
      /*width: 100%;*/
      /*height: 248px;*/
      margin-top: 204px;
      /*background: rgba(0,86,232,1);*/
      /*text-align: center;*/
      height: 200px;
      background: url('~@/assets/images/indexpage/production/tel_bg.png') no-repeat center center;
      background-size: cover;
      p{
        padding-top: 64px;
        width: 100%;
        height: 40px;
        font-size: 32px;
        color: rgba(255,255,255,1);
        line-height: 40px;
      }
      .phone-span{
        padding-top: 40px;
        width: 100%;
        height: 40px;
        font-size: 32px;
        color: rgba(255,255,255,1);
        line-height: 40px;
        i{
          font-size: 32px;
        }
        span{
          vertical-align: middle;
        }
      }
    }
  }

</style>
<script>
import windowResizeMixin from '@/assets/mixins/window-resize'
import documentScrollMixin from '@/assets/mixins/document-scroll'
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import Banner from '_c/PageIndex/Banner/IndexNew.vue'
import Video from '_c/PageIndex/Video/Index.vue'
import LoginBox from '_c/PageIndex/Login/IndexNew.vue'
import FooterGeneral from '_c/common/Footer/FooterGeneral.vue'
export default {
  name: 'IndexPage',
  components: {
    HeaderGeneral,
    Banner,
    LoginBox,
    FooterGeneral,
    Video
  },
  mixins: [windowResizeMixin, documentScrollMixin],
  data () {
    return {
      footerMarginTop: 50,
      scrollTop: 0,
      qrCodeSrc: require('assets/images/login/r2-qr-code.png'),
      isWhite: false, // 页头是白底的（非透明）
      isShow: false // 是否显示登陆框
    }
  },
  mounted () {
    this.isShow = (this.$route.query.willLogin === 'true')
    this.initEvent()
  },
  methods: {
    // 1.0 初始化事件
    initEvent () {
      this.computeHeight()
      this.resizeHandle.resize(() => {
        this.computeHeight()
      })
      this.computeScrollTop()
      this.scrollHandle.scroll(() => {
        this.computeScrollTop()
      })
    },
    // 1.1 初始化 窗口大小监听
    computeHeight () {
      const windowHeight = document.body ? document.body.clientHeight : (document.documentElement ? document.documentElement.clientHeight : 0)
      if (windowHeight && windowHeight > 920) {
        this.footerMarginTop = windowHeight - 920 + 50
      } else {
        this.footerMarginTop = 50
      }
    },
    // 1.2 计算纵向滚动条位置
    computeScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop){
        scrollTop = document.documentElement.scrollTop
      } else if (document.body){
        scrollTop = document.body.scrollTop
      }
      this.scrollTop = scrollTop
    },
    changeLoginShow (show){
      this.isShow = show
      show && this.$refs.backToTop.backToTop()
    }
  }
}
</script>
